import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
// Design tokens first, then base elements, layout, shared components and page-specific rules.
import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/forms.css';
import './styles/pages.css';
import './styles/schedule.css';
import './styles/maps.css';
import './styles/print.css';
import { App } from './app/App';
import { redirectLegacyHash } from './lib/router';

redirectLegacyHash();
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
